module.exports = __webpack_public_path__ + "img/alert.d1493886.png";